import {memo, PropTypes, ShapeComponent, shapeComponent} from "shared/base"
import React, {useMemo} from "react"
import classNames from "classnames"
import {StyleSheet} from "react-native"

/**
 * @typedef {object} ComponentsCardProps
 * @property {object} cardRef
 * @property {unknown} children
 * @property {unknown} childrenBottomRounded
 * @property {object} childrenProps
 * @property {string} className
 * @property {React.ReactNode} footer
 * @property {string} footerBackground
 * @property {string} footerPadding
 * @property {React.ReactNode} header
 * @property {unknown} style
 * @property {React.ReactNode} subHeader
 */

/** @typedef {object} ComponentsCardState */

/**
 * @extends {ShapeComponent<ComponentsCardProps, ComponentsCardState>}
 */
class ComponentsCard extends ShapeComponent {
  static defaultProps = {
    childrenBottomRounded: true
  }

  static propTypes = {
    cardRef: PropTypes.object,
    childrenBottomRounded: PropTypes.bool.isRequired,
    childrenProps: PropTypes.object,
    className: PropTypes.string,
    footer: PropTypes.node,
    footerBackground: PropTypes.string,
    footerPadding: PropTypes.string,
    header: PropTypes.node,
    subHeader: PropTypes.node
  }

  render() {
    const {
      cardRef,
      children,
      childrenBottomRounded,
      childrenProps,
      className,
      footer,
      footerBackground,
      footerPadding,
      header,
      style,
      subHeader,
      ...restProps
    } = this.props

    const backgroundStyle = {}
    const footerStyle = {}

    if (footerBackground) backgroundStyle.background = footerBackground
    if (footerPadding) footerStyle.padding = footerPadding

    const actualStyle = useMemo(() => {
      const actualStyle = Object.assign({}, backgroundStyle)

      if (style) {
        Object.assign(actualStyle, StyleSheet.flatten(style))
      }

      return actualStyle
    }, [backgroundStyle, style])

    return (
      <div className={classNames("components--card", className)} ref={cardRef} style={actualStyle} {...restProps}>
        <div className="card-children" data-children-bottom-rounded={Boolean(!footer && childrenBottomRounded)} {...childrenProps}>
          {header &&
            <div className="card-header">
              {header}
            </div>
          }
          {subHeader &&
            <div className="card-sub-header">
              {subHeader}
            </div>
          }
          {children}
        </div>
        {footer &&
          <div className="card-footer" style={Object.assign(footerStyle, backgroundStyle)}>
            {footer}
          </div>
        }
      </div>
    )
  }
}

export default memo(shapeComponent(ComponentsCard))
